import { useEffect } from "react";
import { useStore } from "zustand";
import { commonRequest } from "@/services/common.request";
import { useUserState } from "@/states/user.state";
import Hotjar from "@hotjar/browser";
import { DEBUGGER } from "@/helper/helper";
export default function useHotjar(isBot: boolean) {
  const {
    hotJarIDSentStatus,
    hotJarID,
    setHotJarIDSentStatus,
    setHotJarID,
    guestToken
  } = useStore(useUserState);
  const [user] = useUserState(state => [state.user]);
  useEffect(() => {
    if (isBot) return;
    async function insertHotjarId() {
      if (hotJarIDSentStatus === "ready" && hotJarID) {
        try {
          await commonRequest.insertHotjarId(hotJarID);
        } catch (error) {
          DEBUGGER('Hotjar ID insert error:', error);
        }
        setHotJarIDSentStatus("sent");
      }
    }
    insertHotjarId();
  }, [isBot, hotJarIDSentStatus, hotJarID, setHotJarIDSentStatus]);
  useEffect(() => {
    if (isBot) return;
    if (process.env.NEXT_PUBLIC_HOTJAR_ENABLED === "false") return;
    let interval: NodeJS.Timeout;
    async function fetchHotjarId() {
      if (hotJarIDSentStatus !== "sent" && guestToken && !hotJarID) {
        setHotJarIDSentStatus("pending");
        interval = setInterval(async () => {
          try {
            const id = getHotjarCookieId();
            const slicedId = sliceUntilFirstDash(id);
            if (slicedId) {
              setHotJarIDSentStatus("ready");
              setHotJarID(slicedId);
              const identifyObject = Object.assign({
                guest_token: guestToken
              }, user?.id ? {
                user_id: user.id
              } : undefined);
              Hotjar.identify(id, identifyObject);
            }
          } catch (err) {
            DEBUGGER("HOTJAR ID => ", err);
          }
        }, 300);
      } else if (interval) {
        clearInterval(interval);
      }
    }
    fetchHotjarId();
    return () => {
      clearInterval(interval);
    };
  }, [isBot, guestToken, hotJarID, hotJarIDSentStatus, setHotJarIDSentStatus, setHotJarID, user?.id]);
  function sliceUntilFirstDash(str: string) {
    return str ? str.slice(0, str.indexOf("-")) : "";
  }
  function getHotjarCookieId() {
    if (typeof document === "undefined" || !document.cookie) return "";
    const hjSessionUserCookie = document.cookie.split("; ").find(cookie => cookie.includes("_hjSessionUser_"));
    if (!hjSessionUserCookie) return "";
    try {
      const hjSessionUser = hjSessionUserCookie.split("=")[1];
      const decodedData = JSON.parse(atob(hjSessionUser));
      return decodedData?.id || "";
    } catch (error) {
      DEBUGGER("Error parsing Hotjar cookie:", error);
      return "";
    }
  }
}
;